module.exports = __webpack_public_path__ + "static/media/order_v2.144f606f.png";